
import { useEffect, useState } from "react";
import ApiService from "../../services/ApiServiceClass";
import { useLoader } from "../useLoader";

export type quoteFileType = {
    id: number,
    filename: string
}

export type ItemsType = {
    id: number,
    name: string,
    price: number,
    price_nzd: number,
    currency: string,
    url: string,
    is_gst_included: number,
    supplier: string,
    supplierPartNo: string,
    with_quote: number,
    quote: quoteFileType
}

export const useGetItemsByRequestID = (requestID: number) => {
    const [itemsByRequestID, setItemsByRequestID] = useState<ItemsType[]>([]);
    const loader = useLoader();

    const fetchItems = async () => {

        try {
            const responseData = await ApiService.getItemsByRequestID(requestID);
            let itemData = [];
            if (responseData.data) {
                itemData = responseData.data.map((item: ItemsType) => ({
                    id: item.id,
                    name: item.name,
                    price: item.price,
                    price_nzd: item.price_nzd,
                    url: item.url,
                    currency: item.currency,
                    is_gst_included: item.is_gst_included,
                    supplier: item.supplier,
                    supplierPartNo: item.supplierPartNo,
                    with_quote: item.with_quote,
                    quote: item.quote
                }));
            }
            setItemsByRequestID(itemData);
            return responseData;
        } catch (error) {
            throw (error);
        }
    }

    const loadItems = async () => {
        try {
            loader?.setIsLoading(true);
            const itemsDO = await fetchItems();
            loader?.setIsLoading(false);
        } catch (error) {
            console.log(error);
            loader?.setIsLoading(false);
        }
    }

    useEffect(() => {
       loadItems();
    },[]);
    return { itemsByRequestID, setItemsByRequestID, fetchItems };
}